<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_327" data-name="Group 327" transform="translate(-315.731 -280.286)">
    <circle id="Ellipse_44" data-name="Ellipse 44" cx="35.201" cy="35.201" r="35.201" transform="translate(315.731 280.286)" fill="#fff"/>
    <path id="Path_100" data-name="Path 100" d="M2615.688,1177.337a20.97,20.97,0,0,0-1.66-8.9c3.612-6.922,3.4-16.941,3.484-19.251a2.942,2.942,0,0,0-.368-1.718.7.7,0,0,0-1.286.248c-.883,4.616-1.2,9.512-3.815,13.608a3.532,3.532,0,0,1-1.853,1.442,7.342,7.342,0,0,1-2.459.234,5.952,5.952,0,0,0,.66-.394,2.522,2.522,0,0,0,.247-.183,4.932,4.932,0,0,0,.587-.477,5.8,5.8,0,0,0,.412-.421c.074-.083.138-.165.2-.248a6.237,6.237,0,0,0,1.421-3.917,6.394,6.394,0,0,0-6.272-6.35,6.3,6.3,0,0,0-4.133,11.092c.129.11.266.22.4.33.082.055.165.119.247.174a5.926,5.926,0,0,0,.66.394c-4.583,1.183-7.957,5.556-7.957,14.338Z" transform="translate(-2267.717 -850.394)" fill="#1a1818"/>
    <path id="Path_101" data-name="Path 101" d="M2622.1,1177.337a20.986,20.986,0,0,1,1.659-8.9c-3.611-6.922-3.332-15.069-3.414-17.379a2.94,2.94,0,0,1,.368-1.718.7.7,0,0,1,1.286.248c.883,4.616,1.128,7.64,3.746,11.736a3.532,3.532,0,0,0,1.853,1.442,7.342,7.342,0,0,0,2.459.234,5.952,5.952,0,0,1-.66-.394,2.493,2.493,0,0,1-.247-.183,4.932,4.932,0,0,1-.587-.477c-.147-.137-.284-.275-.413-.421-.073-.083-.137-.165-.2-.248a6.23,6.23,0,0,1-1.421-3.917,6.393,6.393,0,0,1,6.272-6.35,6.295,6.295,0,0,1,4.132,11.092c-.128.11-.265.22-.4.33-.082.055-.165.119-.247.174a5.926,5.926,0,0,1-.66.394c4.583,1.183,7.957,5.556,7.957,14.338Z" transform="translate(-2267.717 -850.394)" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'A_05',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/A_05.vue